import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import ExternalFilesForm from './ExternalFilesForm';

interface IProps {
    title: string;
    selectedFiles: string;
    externalFiles: any[];

    dropzoneId: string;
    actionUrl: string;
    upload: boolean;
    uploadedFilesChanged: (e: any) => void;
    onDeleteFile: () => void;
    onUploadCompleted: () => void;
    onFileUploadCompleted: (response: any) => void;
    onUpload: () => void;

    closeModal: () => void;
}

const StoreyExternalFilesModal = (props: IProps) => {
    return (
        <Modal
            show={true}
            onHide={props.closeModal}
            bsSize="large"
            autoFocus={false}
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ExternalFilesForm
                    dropzoneId={props.dropzoneId}
                    actionUrl={props.actionUrl}
                    upload={props.upload}
                    onUploadCompleted={props.onUploadCompleted}
                    onUpload={props.onUpload}
                    title={props.title}
                    actionUrlToCustomer={null}
                    uploadToCustomer={null}
                    onUploadToCustomer={null}
                    selectedFile={props.selectedFiles}
                    onSelectedFileChanged={props.uploadedFilesChanged}
                    files={props.externalFiles}
                    onDeleteFile={props.onDeleteFile}
                    onFileUploadCompleted={props.onFileUploadCompleted}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.closeModal}>
                    {Translate('order/plan/modal/close-button')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default StoreyExternalFilesModal;
